import React, { useState, useEffect } from "react";
import { isFieldRequired, getTitleByField, getDescriptionByField } from "../config/commonFunctions";
import LanguageValueField from "./LanguageValueField"; // Ensure this component can handle LanguageValue
import { Typography, Stack, TextField } from "@mui/material";

export default function AdmsIdentifierView({ obj, onChange, label, lang, required, schemaAsObject }) {
    const [notation, setNotation] = useState(obj.getIdentifierNotation());
    const [creator, setCreator] = useState(obj.getCreator()); // State for creator

    // Sync the state with the incoming obj prop
    useEffect(() => {
        setNotation(obj.getIdentifierNotation());
        setCreator(obj.getCreator()); // Sync creator with the incoming obj
    }, [obj]);

    const updateNotation = (e) => {
        const newNotation = e.target.value;
        setNotation(newNotation);
        obj.setIdentifierNotation(newNotation);
        onChange(obj); // Pass the updated object back to the parent
    };

    const handleCreatorChange = (newCreator) => {
        setCreator(newCreator); // Update local state for creator
        obj.setCreator(newCreator); // Set the new creator (should be a LanguageValue)
        onChange(obj); // Update the parent with the new object
    };

    return (
        <Stack spacing={2}>
            <Typography variant="h6">{label}</Typography>
            <TextField
                fullWidth
                variant="filled"
                label={getTitleByField(schemaAsObject, "Identifier.identifier_notation")}
                helperText={getDescriptionByField(schemaAsObject, "Identifier.identifier_notation")}
                value={notation}
                onChange={updateNotation}
                // required={required}
                required={isFieldRequired("notation", schemaAsObject?.$defs?.Identifier)}
            />
            <LanguageValueField
                label={getTitleByField(schemaAsObject, "Identifier.creator")}
                helperText={getDescriptionByField(schemaAsObject, "Identifier.creator")}
                obj={creator}
                lang={lang}
                onChange={handleCreatorChange}
                // required={required}
                required={isFieldRequired("creator", schemaAsObject?.$defs?.Identifier)}
            />
        </Stack>
    );
}
